import { media, styled } from '@styles';
import { Container } from '@components/templates/Container';
import { prismicRichText } from '@styles/utils';

export const Wrapper = styled(Container)``;

export const ContentWrapper = styled.div`
  &-container {
    display: flex;
    ${media.largeScreen`
      display: block;
    `}
  }

  &-column {
    width: 100%;
    &:not(:last-child) {
      margin-right: 40px;
    }
  }

  * {
    line-height: inherit;
  }
  ${prismicRichText}
`;
